@if (isCargoAiDomain) {
  <div
    id="registration-tutorial"
    class="align-items-center align-items-xl-start text-center text-xl-left"
    (window:resize)="onResize()"
  >
    <div id="tutorial-steps">
      <h1 i18n="@@global.steps-to-book">
        Start booking your shipments in two simple steps:
      </h1>
      <ol>
        <li>
          <span i18n="@@global.fill-out">Fill out</span>
          <span class="d-none d-xl-inline" i18n="@@global.this-form"
            >&nbsp;this form&nbsp;</span
          >
          <span class="d-inline d-xl-none" i18n="@@global.form-above"
            >&nbsp;the form above&nbsp;</span
          >
          <span i18n="@@global.in-seconds">in seconds</span>
        </li>
        <li i18n="@@global.search-book-pay">Search, Book, Pay!</li>
      </ol>
    </div>
    <div id="tutorial-video">
      <h2 i18n="@@global.discover-cargomart">
        Discover CargoMART - The Future of Digital Airfreight Starts Here
      </h2>
      <video id="singleVideo" preload="metadata" crossorigin controls>
        <source
          src="/static/videos/cargoai-product-intro.mp4"
          type="video/mp4"
        />
      </video>
    </div>
  </div>
}
